// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AzTYezoBFm8VDtipifHv4A\\=\\= {\n  width: 250px;\n}\n", "",{"version":3,"sources":["webpack://src/components/search/_styles.less"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF","sourcesContent":[".search {\n  width: 250px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": "AzTYezoBFm8VDtipifHv4A=="
};
export default ___CSS_LOADER_EXPORT___;
